









































































































































































import Vue from "vue";
import store, {
  OutgoingInvoiceTypeEditModelStore,
} from "../services/OutgoingInvoiceTypeEditModelStore";
import Page from "../../../components/Page.vue";
import OutgoingInvoiceTypeEditModel from "../models/OutgoingInvoiceTypeEditModel";
import setAttribute from "../../../utils/dom";
import { t } from "@/plugins/i18n";

interface Data {
  store: OutgoingInvoiceTypeEditModelStore;
}

const confirmationTemplate = {
  mounted() {
    setAttribute(".k-detail-cell", "colspan", "12");
  },
};

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    Page,
    confirmation: confirmationTemplate,
  },

  data(): Data {
    return {
      store,
    };
  },

  async beforeMount() {
    await this.store.loadOutgoingInvoiceTypeEditModels();
  },

  computed: {
    columns: () => [
      {
        field: "name",
        title: t("OutgoingInvoiceType_KimenoSzlaTipus"),
      },
      {
        field: "default",
        title: t("Alapertelmezett"),
        cell: "defaultTemplate",
      },
      {
        field: "isCar",
        title: t("OutgoingInvoiceType_GjTart"),
        cell: "isCarTemplate",
      },
      {
        field: "isCarItem",
        title: t("OutgoingInvoiceType_GjSzlaTet"),
        cell: "isCarItemTemplate",
      },
      {
        field: "isMoreGparts",
        title: t("OutgoingInvoiceType_AzonCikk"),
        cell: "isMoreGpartsTemplate",
      },
      { field: "detailedType", title: t("FokTetelTipus") },
      {
        field: "isNoGparts",
        title: t("OutgoingInvoiceType_CikkSzolgNelkul"),
        cell: "isNoGpartsTemplate",
      },
      {
        field: "isFixAssets",
        title: t("TargyiEszkoz"),
        cell: "isFixAssetsTemplate",
      },
      {
        field: "isStockFin",
        title: t("Keszletfinansz"),
        cell: "isStockFinTemplate",
      },
      {
        field: "isPrintOwnerRun",
        title: t("OutgoingInvoiceType_UzembentartoSzlaRa"),
        cell: "isPrintOwnerRunTemplate",
      },
      {
        field: "technVatAccCode",
        title: t("OutgoingInvoiceType_TechnAfaFkSzam_2"),
      },
      { cell: "commandTemplate", width: "80px" },
    ],

    items() {
      return this.store.outgoingInvoiceTypeEditModels;
    },
  },

  methods: {
    createOutgoingInvoiceTypeEditModel() {
      this.$router.push(`/outgoing-invoice/type/create`);
    },

    updateOutgoingInvoiceTypeEditModel(item: OutgoingInvoiceTypeEditModel) {
      this.$router.push(`/outgoing-invoice/type/${item.id}/edit`);
    },

    deleteItem(item: OutgoingInvoiceTypeEditModel) {
      this.store.setDeleting(item);
    },

    confirmDelete(item: OutgoingInvoiceTypeEditModel) {
      item.deleting = false;
      this.store.deleteoutgoingInvoiceTypeEditModel(item);
    },

    cancelDelete(item: OutgoingInvoiceTypeEditModel) {
      item.deleting = false;
    },
  },
});
